// extracted by mini-css-extract-plugin
export default {"upsell":"UpsellPages_upsell__nnrTT","footer":"UpsellPages_footer__iTDzk"};